import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { registerPopup, hidePopup as hidePopupAction, destroyPopup } from './reducers'
import { popupVisible } from './selectors'

import { Popup } from '@offerzen/pinata-shame'

const PopupRedux = ({ dispatchRegisterPopup, dispatchDestroyPopup, hidePopup, visible, ...props }) => {
  const { name } = props

  useEffect(() => {
    dispatchRegisterPopup(name)

    return () => {
      dispatchDestroyPopup(name)
    }
  }, [name, dispatchRegisterPopup, dispatchDestroyPopup])

  return (
    <Popup
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      hidePopup={() => hidePopup(name)}
      visible={visible}
    />
  )
}

const mapStateToProps = (state, ownProps) => {
  const visible = popupVisible(state, ownProps.name)
  return { visible }
}

const mapDispatchToProps = {
  dispatchRegisterPopup: registerPopup,
  dispatchDestroyPopup: destroyPopup,
  hidePopup: hidePopupAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupRedux)

PopupRedux.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  theme: PropTypes.string,
  onPopupClose: PropTypes.func,
  preventClose: PropTypes.bool,
  children: PropTypes.func.isRequired,
  dispatchRegisterPopup: PropTypes.func.isRequired,
  dispatchDestroyPopup: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  hidePopup: PropTypes.func.isRequired,
}
